import * as Sentry from '@sentry/vue';

const isSentryDisabled =
    process.env.VUE_APP_SENTRY_DISABLED?.toLocaleLowerCase() === 'true';
const dsn = process.env.VUE_APP_SENTRY_DSN;

export default {
    install(Vue) {
        if (isSentryDisabled || !dsn) {
            console.log('Sentry is disabled');
            return;
        }
        Sentry.init({
            Vue,
            dsn,
            integrations: [
                Sentry.captureConsoleIntegration({ levels: ['error'] }),
                Sentry.httpClientIntegration({
                    failedRequestStatusCodes: [[400, 599]],
                }),
            ],
            sendDefaultPii: true,
            tracesSampleRate: 0.2,
            tracePropagationTargets: [],
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
        });
    },
};
